module.exports = __webpack_public_path__ + "static/media/3519a458-3450-46e7-bd8b-abb0d4cbbb59.0f643305.png";